import { render, staticRenderFns } from "./cardVolunteerTeamOffer.vue?vue&type=template&id=2542e130&scoped=true"
import script from "./cardVolunteerTeamOffer.vue?vue&type=script&lang=js"
export * from "./cardVolunteerTeamOffer.vue?vue&type=script&lang=js"
import style0 from "./cardVolunteerTeamOffer.vue?vue&type=style&index=0&id=2542e130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2542e130",
  null
  
)

export default component.exports